const getImageDataURL = (file) =>
	new Promise((res, rej) => {
		var reader = new FileReader();

		reader.addEventListener("load", () => {
			res(reader.result);
		});
		reader.addEventListener("error", (err) => rej(err));

		reader.readAsDataURL(file);
	});

const MAX_WIDTH_OR_HEIGHT = 500;

const processImage = async (dataURL) => {
	// Using canvas fixes EXIF issues, so is by far the best option.

	const image = await new Promise((res, rej) => {
		const blank = new Image();

		const timer = setTimeout(
			rej.bind(null, "Image took too long to compress. Please try again"),
			10000
		);

		blank.onload = function () {
			clearTimeout(timer);
			res(this);
		};

		blank.onerror = function () {
			clearTimeout(timer);
			rej("That file could not be read as an image. Please try another.");
		};

		blank.src = dataURL;
	});

	// Scale the longest side down to the maximum, keeping the aspect ratio.
	// Never scale up — an already-small image gains nothing but bytes.
	const scale = Math.min(
		1,
		MAX_WIDTH_OR_HEIGHT / Math.max(image.width, image.height)
	);

	const width = Math.round(image.width * scale);
	const height = Math.round(image.height * scale);

	const canvas = document.createElement("canvas");
	canvas.width = width;
	canvas.height = height;

	const context = canvas.getContext("2d");

	// JPEG has no alpha channel, so transparent pixels would come out black
	context.fillStyle = "#ffffff";
	context.fillRect(0, 0, width, height);
	context.drawImage(image, 0, 0, width, height);

	// JPEG, not PNG: `toDataURL` ignores the quality argument for PNG, so
	// every photo was being stored losslessly at roughly ten times the size.
	return canvas.toDataURL("image/jpeg", 0.8);
};

export const applyImageCorrections = async (image) => {
	// Convert file to base 64
	console.log("Converting image to base 64");
	let dataURL = await getImageDataURL(image);

	console.log("Processing image");
	dataURL = await processImage(dataURL);

	return dataURL;
};

// A list edit must carry the whole field back to the record, not just its
// items. Reducing the field to `{ items }` drops its `uid`, and a change with
// no `uid` used to be written over whichever field also had none.
export const addListItem = (field, item) => ({
	...field,
	items: [...(field.items || []), item],
});

export const removeListItem = (field, index) => ({
	...field,
	items: (field.items || []).filter((_, i) => i !== index),
});
